import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Shell, Card } from "../components/Layout";
import { Button } from "../components/ui/button";
import { ChangePassword } from "../components/ChangePassword";
import { useAuth } from "../context/AuthContext";
import { apiError, http } from "../lib/api";

export default function PerfilHome() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [confirm, setConfirm] = useState(false);
  const [error, setError] = useState("");
  return (
    <Shell title={`Bienvenido, ${user?.family_name || ""}`}
      subtitle="Seleccione el área que desea consultar. Puede cambiar de área en cualquier momento."
      testid="perfil-home-page">
      <div className="grid gap-8 md:grid-cols-2">
        <Card>
          <h2 className="font-head text-2xl font-medium">Centro de Estudios</h2>          <p className="mt-3 text-lg text-ink-700">
            Horario, cambios de grupo, ausencias y recuperaciones, exámenes y mensualidad.
          </p>
          <Button data-testid="perfil-centro-btn" onClick={() => navigate("/perfil/centro")}
            className="mt-6 h-14 w-full bg-centro text-lg hover:bg-centro-hover">
            Acceder a Centro de Estudios
          </Button>
        </Card>
        <Card>
          <h2 className="font-head text-2xl font-medium">Logopedia</h2>
          <p className="mt-3 text-lg text-ink-700">
            Sesiones reservadas, estado del bono, anamnesis y material a aportar.
          </p>
          <Button data-testid="perfil-logopedia-btn" onClick={() => navigate("/perfil/logopedia")}
            className="mt-6 h-14 w-full bg-logo text-lg hover:bg-logo-hover">
            Acceder a Logopedia
          </Button>
        </Card>
      </div>

      <div className="mt-10">
        <ChangePassword testid="family-password" />
      </div>

      <Card className="mt-10 border-red-200">
        <h2 className="font-head text-2xl font-medium">Dar de baja mi cuenta</h2>
        <p className="mt-2 text-lg text-ink-700">
          Si da de baja su cuenta se eliminarán de la web todos sus datos y los de sus alumnos y
          pacientes: horarios, ausencias, exámenes, sesiones, bonos y anamnesis. Sus plazas quedarán
          libres de inmediato para otras familias. Esta acción no se puede deshacer y no será
          necesario avisar al centro.
        </p>
        {error && <p data-testid="baja-error" className="mt-4 rounded-lg bg-red-50 p-4 text-base text-red-700">{error}</p>}
        {confirm ? (
          <div className="mt-4 flex flex-wrap gap-3">
            <Button data-testid="confirm-baja-account-btn" className="h-14 bg-red-700 text-lg hover:bg-red-800"
              onClick={async () => {
                setError("");
                try {
                  await http.delete("/account");
                  localStorage.removeItem("sisu_token");
                  await logout();
                  navigate("/");
                } catch (err) {
                  setError(apiError(err));
                }
              }}>
              Sí, dar de baja mi cuenta y borrar mis datos
            </Button>
            <Button data-testid="cancel-baja-account-btn" variant="outline" className="h-14 text-lg"
              onClick={() => setConfirm(false)}>
              No, conservar mi cuenta
            </Button>
          </div>
        ) : (
          <Button data-testid="baja-account-btn" variant="outline" className="mt-4 h-14 text-lg"
            onClick={() => setConfirm(true)}>
            Dar de baja mi cuenta
          </Button>
        )}
      </Card>
    </Shell>
  );
}
